import React from 'react';

import './index.css';

type TabsProps = {
    className?: string;
    tabs: React.ReactNode[];
    tabIndex: number;
    onSelect: (() => void)[];
};

function Tabs({
    className,
    tabs,
    tabIndex,
    onSelect
}: TabsProps) {
    return (
        <div className={`tabs ${className}`}>
            {tabs.map((tab, t) => (
                <h3
                    className={tabIndex === t ? 'tab--active' : 'tab'}
                    onClick={onSelect[t]}
                >
                    {tab}
                </h3> 
            ))}
        </div>
    );
}

export default Tabs;